export default "__VITE_ASSET__pSok4Bh$__"